import { render, staticRenderFns } from "./ResellerActivity.vue?vue&type=template&id=68d768cc&scoped=true&"
import script from "./ResellerActivity.vue?vue&type=script&lang=js&"
export * from "./ResellerActivity.vue?vue&type=script&lang=js&"
import style0 from "./ResellerActivity.vue?vue&type=style&index=0&id=68d768cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d768cc",
  null
  
)

export default component.exports